import { render, staticRenderFns } from "./InputSepSimplePage.vue?vue&type=template&id=6909e556&scoped=true&"
import script from "./InputSepSimplePage.vue?vue&type=script&lang=ts&"
export * from "./InputSepSimplePage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6909e556",
  null
  
)

export default component.exports